export default {
    methods: {
        navigateTo(target, isLink=false, mixpanelEvent=null) {
            let name = '';
            let params = null;
            let query = null;
            if (typeof target === 'object') {
                name = target.name;
                params = target.params;
                query = target.query;
            } else {
                name = target;
            }

            if (mixpanelEvent !== null) {
                this.trackMixpanelEvent(mixpanelEvent);
            }
            if (isLink) {
                window.open(name, '_blank');
            } else {
                let data;
                // Check if target is a path (starts with /) or route name
                if (typeof target === 'string' && target.startsWith('/')) {
                    data = { path: target };
                    if (query !== null) {
                        data = {...data, query};
                    }
                } else {
                    data = {name};
                    if (params !== null) {
                        data = {...data, params};
                    }
                    if (query !== null) {
                        data = {...data, query};
                    }
                }
                this.$router.push(data).catch(error => {
                    if (error.name === 'NavigationDuplicated') {
                        window.location.reload();
                    } else {
                        throw error;
                    }
                });
            }
        },
    },
};